module.exports = __webpack_public_path__ + "our-team.jpg?e345586d8a9d7783a8781918f5b4b7b6";


//////////////////
// WEBPACK FOOTER
// ./public/img/team/our-team.jpg
// module id = 568
// module chunks = 4